import * as React from 'react';
import { IconButton } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';

const ExpanderToggle = ({ label , isExpanded , onToggleClick  })=>/*#__PURE__*/ React.createElement(IconButton, {
        outline: true,
        onClick: onToggleClick,
        "aria-expanded": isExpanded,
        "aria-label": label,
        "data-t": "expander-toggle",
        className: "configurator-footer-expander-toggle"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-up",
        height: 18,
        width: 18
    }))
;

export { ExpanderToggle };
//# sourceMappingURL=ExpanderToggle.js.map
